<div class="d-flex flex-column align-items-center mt-5" #origin>
    <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[900px] overflow-auto max-h-[80vh]">
        <h3>Send Candidate Email Messages</h3>
        <form class="mr-0 d-flex flex-column align-items-center" (ngSubmit)="confirmRecipientCount(origin)">
            <div class="mb-3 mr-0 col-md-10">
                <label class="form-label">Subject</label>
                <input class="form-control" type="text" [(ngModel)]="sendEmailMessageData.emailSubject"
                    name="subject" />
            </div>
            <div class="mb-3 mr-0 col-md-10">
                <label class="form-label">Candidate Number. List</label>
                <textarea class="form-control p-1" rows="2" [(ngModel)]="matricNoList" name="matricNoList"></textarea>
            </div>
            <!-- <div class="mb-3 mr-0 col-md-10" *ngIf="this.selectedExam?.id<=0">

                <label class="form-label">Select Examination</label>
                <ng-select [items]="exams" [(ngModel)]="selectedExam" name="selectedExam" bindLabel="examinationName"
                    bindValue="id" [searchFn]="customSearchFn" [searchable]="true" placeholder="Select an Examination">
                </ng-select>

            </div> -->

            <div class="row col-md-10" *ngIf="selectedExam">
                <div class="col-md-6 mb-3">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="checkbox1"
                            [(ngModel)]="sendEmailMessageData.sendLoginLink" name="sendLoginLink" />
                        <label class="form-check-label" for="checkbox1">
                            Send Login Link
                        </label>
                    </div>
                </div>
                <div class="col-md-6 mb-3">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="checkbox2"
                            [(ngModel)]="sendEmailMessageData.sendSEBLink" name="sendSEBLink">
                        <label class="form-check-label" for="checkbox2">
                            Send SEB Link
                        </label>
                    </div>
                </div>

                <div class="col-md-6 mb-3" *ngIf="selectedExam">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="checkbox4"
                            [(ngModel)]="sendEmailMessageData.sendExaminationTimeTable" name="sendExaminationTimeTable">
                        <label class="form-check-label" for="checkbox4">
                            Send Examination Timetable
                        </label>
                    </div>
                </div>
            </div>

            <div class="mb-3 mr-0 col-md-10">
                <div class="mb-2">
                    <h5>Possible Placeholder Options</h5>
                    <p>Use the following placeholders to customize your message. <span class="text-primary">Click on the
                            placeholder to copy it</span></p>
                    <ul class="flex-grid">
                        <span class="btn btn-outline-secondary placeholder-tag"
                            (click)="copyPlaceholder('{candidate_fullname}', $event)">
                            Candidate Fullname
                        </span>

                        <span class="btn btn-outline-secondary placeholder-tag" (click)="copyPlaceholder('{candidate_exam_number}', $event)">
                            Candidate Exam Number
                        </span>
                        <span class="btn btn-outline-secondary placeholder-tag" (click)="copyPlaceholder('{candidate_firstname}', $event)">
                            Candidate FirstName
                        </span>
                        <span class="btn btn-outline-secondary placeholder-tag" (click)="copyPlaceholder('{candidate_lastname}', $event)">
                            Candidate LastName
                        </span>
                        <span *ngIf="selectedExam" class="btn btn-outline-secondary placeholder-tag"
                            (click)="copyPlaceholder('{exam_name}', $event)">
                            Exam Name
                        </span>
                        <span *ngIf="selectedExam" class="btn btn-outline-secondary placeholder-tag"
                            (click)="copyPlaceholder('{exam_start_datetime}', $event)">
                            Exam Start Datetime
                        </span>

                        <span *ngIf="selectedExam" class="btn btn-outline-secondary placeholder-tag"
                            (click)="copyPlaceholder('{exam_end_datetime}', $event)">
                            Exam End Datetime
                        </span>

                        <span *ngIf="selectedExam" class="btn btn-outline-secondary placeholder-tag"
                            (click)="copyPlaceholder('{exam_duration}', $event)">
                            Exam Duration
                        </span>

                        <span *ngIf="selectedExam" class="btn btn-outline-secondary placeholder-tag"
                            (click)="copyPlaceholder('{schedule_start_datetime}', $event)">
                            Schedule Start Datetime
                        </span>

                        <span *ngIf="selectedExam" class="btn btn-outline-secondary placeholder-tag"
                            (click)="copyPlaceholder('{schedule_end_datetime}', $event)">
                            Schedule End Datetime
                        </span>


                        <span *ngIf="selectedExam && selectedExam.useSEB"
                            class="btn btn-outline-secondary placeholder-tag"
                            (click)="copyPlaceholder('{seb_instructions}', $event)">
                            SEB Instructions
                        </span>
                    </ul>

                    <!-- Toast -->
                    <div *ngIf="toast.visible" class="copy-toast"
                        [ngStyle]="{ top: toast.y + 'px', left: toast.x + 'px' }">
                        Copied and inserted!
                    </div>



                </div>
                <label class="form-label">Message</label>
                <quill-editor #editor [(ngModel)]="sendEmailMessageData.message" name="message"
                    (onEditorCreated)="onEditorReady($event)">
                </quill-editor>
            </div>

            <div class=" d-flex justify-content-between col-md-10">
                <button class="btn btn-primary btn-lg col-md-5 " type="submit"
                    [disabled]="!sendEmailMessageData.message || !sendEmailMessageData.emailSubject">
                    Send
                </button>
                <button type="button" class="btn btn-warning btn-lg col-md-5 " (click)="saveDraft()">
                    Save Draft
                </button>
            </div>

        </form>
    </div>
</div>